import SettingsIcon from '@mui/icons-material/Settings';
import GroupIcon from '@mui/icons-material/Group';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import MovingIcon from '@mui/icons-material/Moving';
import EmailIcon from '@mui/icons-material/Email';
import TelegramIcon from '@mui/icons-material/Telegram';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';

export const AdminMenuItems = [
  {
    header: "تنظیمات",
    headerIcon: SettingsIcon,
    items: [
      {
        name: "شهرها",
        route: "/setting-city",
        isActive: "cities",
      },
      {
        name: "مشتریان",
        route: "/setting-customer",
        isActive: "customers",
      },
      {
        name: "کارمندان",
        route: "/setting-employee",
        isActive: "employee",
      },
      {
        name: "تولیدکنندگان",
        route: "/setting-producer",
        isActive: "producers",
      },
      {
        name: "برندها",
        route: "/setting-brand",
        isActive: "brands",
      },
      {
        name: "النگوها",
        route: "/setting-ring",
        isActive: "rings",
      },
      {
        name: "النگو‌ها - جدول",
        route: "/setting-table-ring",
        isActive: "table-rings",
      },
      {
        name: "ثبت موجودی",
        route: "/setting-stock",
        isActive: "stocks",
      },
      {
        name: "موجودی",
        route: "/setting-stock-table",
        isActive: "stocks-table",
      },
      {
        name: "موجودی سفارش تولیدکننده",
        route: "/setting-provider-stock",
        isActive: "provider-stocks",
      },
      {
        name: "تنظیمات نمایش",
        route: "/setting-set-parameter",
        isActive: "parameter",
      },
    ],
  },
  {
    header: "مشتریان",
    headerIcon: GroupIcon,
    items: [
      {
        name: "ثبت سفارش",
        route: "/create-order-customer",
        isActive: "c-create-order",
      },
      {
        name: "سفارش‌های جدید",
        route: "/customers-new-orders",
        isActive: "c-new-orders",
      },
      {
        name: "سفارش‌های جاری",
        route: "/customers-current-orders",
        isActive: "c-current-orders",
      },
      {
        name: "سفارش‌های تحویل داده‌شده",
        route: "/customers-deliverd-orders",
        isActive: "c-deliverd-orders",
      },
      {
        name: "سفارش‌های لغو شده",
        route: "/customers-cancelled-orders",
        isActive: "c-cancelled-orders",
      },
    ],
  },
  {
    header: "مرجوعی",
    headerIcon: AssignmentReturnIcon,
    items: [
      // {
      //   name: "ثبت مرجوعی",
      //   route: "/returned-order",
      //   isActive: "returned-order",
      // },
      {
        name: "لیست مرجوعی",
        route: "/returned-order-list",
        isActive: "returned-order-list",
      },
    ],
  },
  {
    header: "تولیدکنندگان",
    headerIcon: ShoppingBasketIcon,
    items: [
      {
        name: "ثبت سفارش",
        route: "/create-order-producer",
        isActive: "p-create-order",
      },
      {
        name: "سفارش‌های منتظر تایید",
        route: "/provider-waiting-orders",
        isActive: "p-waiting-orders",
      },
      {
        name: "سفارش‌های جاری",
        route: "/provider-current-orders",
        isActive: "p-current-orders",
      },
      {
        name: "سفارش‌های منتظر تایید",
        route: "/provider-need-confirmed-orders",
        isActive: "p-need-confirmed-orders",
      },
      {
        name: "سفارش‌های تحویل گرفته‌شده",
        route: "/provider-received-orders",
        isActive: "p-received-orders",
      },
    ],
  },
  {
    header: "گزارشات",
    headerIcon: LocalPrintshopIcon,
    items: [
      {
        name: "اطلاعات کلی النگوها",
        route: "/report-bangles-informations",
        isActive: "r-general-info",
      },
      {
        name: "درخواست / موجودی / ثبتی",
        route: "/report-request-inventory-register",
        isActive: "r-request-inventory-register",
      },
      {
        name: "وضعیت النگو تولیدکنندگان",
        route: "/report-provider-bangle",
        isActive: "r-request-provider-bangle",
      },
      {
        name: "پذیرش ادمین",
        route: "/report-accept-order-admin",
        isActive: "r-accept-order-admin",
      },
      {
        name: "سفارش / موجودی",
        route: "/report-order-stock",
        isActive: "r-order-stock",
      },
      {
        name: "درخواست مشتریان",
        route: "/report-bangle-onprogress-customer",
        isActive: "r-bangle-customer",
      },
      {
        name: "النگوهای فروخته شده",
        route: "/report-bangle-sold",
        isActive: "r-bangle-sold",
      },
    ],
  },
  {
    header: "دسترسی سریع",
    headerIcon: MovingIcon,
    items: [
      {
        name: "تغییر مشتری",
        route: "/quick-access-change-customer",
        isActive: "q-change-customer",
      },
      {
        name: " ویرایش سفارش",
        route: "/quick-access-edit-order",
        isActive: "q-edit-order",
      },
      {
        name: "تغییر وضعیت سفارش",
        route: "/quick-access-order-state-change",
        isActive: "q-order-state-change",
      },
      {
        name: "لغو سفارش",
        route: "/quick-access-delete-order",
        isActive: "q-delete-order",
      },
      {
        name: "حذف سفارش",
        route: "/quick-access-remove-order",
        isActive: "q-remove-order",
      },
      {
        name: "رکورد‌های سفارش",
        route: "/quick-access-log-order",
        isActive: "q-log-order",
      },
    ],
  },
  {
    header: "پیام رسان",
    headerIcon: EmailIcon,
    items: [],
    route: "/send_messages",
  },
  {
    header: "گفتگوها",
    headerIcon: TelegramIcon,
    items: [],
    route: "/chats",
    haveBadge: true,
  },
];
